<template>
  <div>
    <div class="grid-container">
      <app-message v-if="submitted === true"  :enquiryId="enquiryId" :enquiryNumber="enquiryNumber" />
    </div>
    

    <div id="detail" class="grid-container full container">
      

      <div class="grid-container" v-if="submitted === false">
        <div class="grid-x grid-padding-x">
          <div class="cell text-center">
            <h2>
              Your Enquiry List
            </h2>
            <p v-if="isAuthenticated">
              {{ items.length }} Item(s) in your enquiry list
            </p>
          </div>

          <div v-if="isAuthenticated" class="cell">
            <div class="callout primary" style="border: none;">
              After selecting all you need and summiting your enquiry, 
              ONEBUY sales will verify your order and offer discount accordingly. 
              Enjoy your selection!
            </div>
          </div>

          <div
            v-if="isAuthenticated"
            class="product-details product-detail-photos cell"
          >
            <div class="grid-x grid-padding-x">
              <div class="cell large-9">
                <div
                  class="details-header grid-x grid-padding-y text-uppercase"
                  style="border-bottom: 1px solid grey;"
                >
                  <div class="cell text medium-6">Product details</div>
                  <div class="cell text medium-2 text-center">Price(EXW)</div>
                  <div class="cell text medium-2 text-center">Quantity</div>
                  <div class="cell text medium-2 text-center">SubTotal</div>
                </div>

                <div 
                  v-for="(item, index) in items"
                  :key="index"
                  class="details-description grid-x padding-top-1"
                  style="border-bottom: 1px solid grey;"
                >
                  <div v-if="item.product" class="cell medium-6">
                    <div class="grid-x">
                      <div class="cell large-2">
                        <router-link
                          class="h6"
                          :to="{
                            name: 'product-detail',
                            params: {
                              catalog: item.product.categoryFk,
                              productId: item.product.id,
                            }
                          }"
                        >
                          <img
                            :src="baseUrl + item.product.imgPath"
                            width="110"
                            class="radius"
                          />
                        </router-link>
                      </div>
                      <div class="cell large-10">
                        
                      <div class="padding-left-1">
                        <router-link
                          class="h6 "
                          style="font-weight: bold;"
                          :to="{
                            name: 'product-detail',
                            params: {
                              catalog: item.product.categoryFk,
                              productId: item.product.id,
                            }
                          }"
                        >
                          {{ item.product.nameInfo.contentData }}
                        </router-link>
                        <p>
                          {{ item.product.descriptionInfo.contentData }} /
                          {{ item.isStandard ? "S" : "C" }}
                        </p>

                         <!-- <button
                              class="button hollow radius alert" style="margin-right: 1rem;"
                              @click="deleteItem(item)"
                              :disabled="loading" 
                            >
                            Remove
                          </button> -->

                          <!-- <ul v-show="item.isStandard===false && (item.remarks && item.remarks.trim().length>0)"
                            style="display: inline-block;" 
                            class="dropdown menu" data-dropdown-menu>
                            <li>
                              <button class="button hollow radius">
                                Size Info
                              </button>
                              <ul class="menu" >
                                <li class="menu-text">
                                    {{item.remarks}}
                                </li>
                              </ul>
                            </li>
                            
                          </ul> -->
                        
                          <!-- <button v-show="item.isStandard===false && (item.remarks && item.remarks.trim().length>0)" 
                            class="button hollow radius" type="button" :data-toggle="'remarks_' + item.id"
                            
                            :disabled="loading"
                          >
                            Size Info
                          </button> -->
                          <!-- <div v-if="item.remarks && item.remarks.trim().length>0" 
                            class="dropdown-pane radius callout primary" data-position="top" data-alignment="left" 
                          :id="'remarks_' + item.id" 
                          data-dropdown
                          data-hover="true"
                          style="font-size: 0.75rem;"
                          >
                            {{ item.remarks ? JSON.parse(item.remarks) : ''}}
                          </div> -->

                          <!-- <button
                            class="button radius" type="button" :data-toggle="'remarks_' + item.id"
                            :class="{'secondary clear': item.isStandard}"
                            :disabled="loading"
                          >
                            {{item.isStandard ? 'Standard': 'Custom'}}
                          </button> -->

<label> Size Standard &nbsp;
                              <input type="checkbox" v-model="item.isStandard" :disabled="loading" @change="onChangeProduct(item)" />
                              </label>
                          <!-- <textarea
                              v-show="!item.isStandard"
                              v-model="item.remarksParsed"
                              @change="item.remarks=JSON.stringify(item.remarksParsed)"
                              placeholder="Please enter custom size details here."
                              class=""
                              :disabled="loading"
                            ></textarea> -->
                      </div>

                      </div>
                      
                    </div>
                  </div>
                  <div class="cell medium-2 text-center">
                    {{ (item.product.marketPrice || 0).toFixed(2) }} USD
                  </div>
                  <div class="cell medium-2 text-center">
                    <div class=" text-center" style="margin:0 auto;">
                      <product-counter
                        v-model="item.count"
                        :min="1"
                        :max="5000"
                        :disabled="loading"
                        @change="onChangeProduct(item)"
                      />

                      <div class="product-quantity-info">
                        <div class="quantity-unit">
                          <span class="">
                            <select v-model="item.uoMFk"
                            :disabled="true"
                            @change="onChangeProduct(item)"
                            >
                              <option v-for="(item, index) in uomList" :key="index" :value="item.id">{{item.name}}</option>
                            </select>
                          </span>
                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="cell medium-2 text-center">
                    <!-- {{ item.totalCost.toFixed(2) }} USD -->
                    {{ (item.product.marketPrice * item.count).toFixed(2) }} USD
                  </div>

      <div class="cell large-1">
                        
                  </div>
                  <div class="cell large-5">
                          <textarea
                              v-show="!item.isStandard"
                              v-model="item.remarksParsed"
                              @change="item.remarks=JSON.stringify(item.remarksParsed); onChangeProduct(item);"
                              placeholder="Please enter custom size details here."
                              :disabled="loading"
                              style="    margin: 0;
    margin-left: 1rem;
    margin-bottom: 1rem;"
                            ></textarea>
                  </div>
                  <div class="cell large-6 text-right">
                        <button 
                        @click="deleteItem(item)"
                        :disabled="loading" 
                        class="button clear alert" style="margin-bottom:0;">
                          Remove
                        </button>
                  </div>
                            
                </div>
              </div>

              <div class="cell large-3">

                <div
                  class="details-header grid-x grid-padding-y text-uppercase"
                  style="border-bottom: 1px solid grey;"
                >
                  <div class="cell text-center">Cart Totals</div>
                </div>

                <div class="cell">

                 <div class="grid-x grid-padding-x">
                    <div class="cell medium-6 padding-top-1">
                      SubTotal
                    </div>
                    <div class="cell medium-6 padding-top-1">
                      {{ total.toFixed(2) }} USD
                    </div>

                    <div class="cell medium-6 padding-top-1">
                      Shipping
                    </div>
                    <div class="cell medium-6 padding-top-1 product-quantity-info" style="margin:0;">
                      <div class="quantity-unit" style="margin:0;">
                        <select v-model="shippingFee"
                            :disabled="loading"
                            >
                          <option v-for="(item, index) in shippingFeeList" :key="index" :value="item.id">{{item.name}}</option>
                        </select>
                      </div>
                      <p v-if="shippingFeeSelected && shippingFeeSelected.hint && shippingFeeSelected.hint.length > 0">{{shippingFeeSelected.hint}}</p>
                    </div>
                    

                    <div class="cell medium-6 padding-top-1">
                      Total
                    </div>
                    <div class="cell medium-6 padding-top-1">
                      <!-- {{ total.toFixed(2) }} USD -->
                      <span class="font-bold">To Quote</span>
                    </div>

                    <div class="cell padding-top-1">
                      <textarea v-model="comments"
                      style="min-height:90px;" 
                      placeholder="Enter your comments here..."
                      :disabled="loading">
                      
                      </textarea>
                    </div>
                    <div class="cell padding-top-1">
                      <button
                        @click="continueOrder"
                        class="button expanded radius text-uppercase secondary"
                        :disabled="loading"
                      >
                        Continue My Selection
                      </button>
                    </div>

                    <div class="cell">
                       <button
                        class="button radius expanded text-uppercase"
                        @click="submitOrder"
                        :disabled="items.length === 0 || loading || cartButton.status===1" 
                      >
                      
                        <span v-show="cartButton.status===1" class="text-uppercase">
                          Submitting...
                        </span>

                        <span v-show="cartButton.status===2" class="text-uppercase"
                          >Submitted
                        </span>

                        <span v-show="cartButton.status===0" class="text-uppercase">
                          Submit
                        </span>

                      </button>
                    </div>

                  </div>

                </div>
                
              </div>
            </div>
          </div>

          <div v-if="!isAuthenticated" class="cell">
            <div class="grid-x grid-padding-x container">
              <div class="cell large-6 text-center container">
                <h3 class="font-bold">
                  Got an account?
                </h3>
                <p class="padding-bottom-1">
                  We saved your cart to your account. <br />
                  Simply login to retrieve your cart items.
                </p>
                <router-link
                  :to="{ name: 'login' }"
                  class="text-uppercase button radius large"
                >
                  Account login
                </router-link>
              </div>
              <div class="cell large-6 text-center container">
                <h3 class="font-bold">
                  Guest Customer?
                </h3>
                <p class="padding-bottom-1">
                  Did you start shopping on a different device? <br />
                  Create an account to access your cart on all your devices.
                </p>
                <router-link id="createAccountBtn"
                  :to="{ name: 'register' }"
                  class="text-uppercase button radius secondary large"
                >
                  Create an account
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Needs to Login Or Register Message-->
    <div class="reveal" id="exampleModal1" data-reveal>
      <h1>Submit Almost Done</h1>
      <p class="lead">
        Your are not signed in yet.
      </p>
      <p>
        Please
        <router-link :to="{ name: 'login' }" style="" data-close>
          Sign In
        </router-link>
        Or
        <span>Or</span>
        <router-link :to="{ name: 'register' }" style="" data-close>
          Register
        </router-link>
      </p>
      <button
        class="close-button"
        data-close
        aria-label="Close modal"
        type="button"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <button
      ref="modal"
      class="button"
      data-open="exampleModal1"
      style="visibility:hidden;opacity:0;"
    ></button>

    <!--Space-->
    <div class="container"></div>
  </div>
</template>

<script>
import _ from "@/app/services/utils-service.js";
import "owl.carousel";
import { EventBus } from "@/app/event-bus";
import uomDataService from "@/app/services/uom-main-service.js";
import shoppingCartDataService from "@/store.order/services/shopping-cart-service.js";
import configService from "@/app/config-service.js";
import userInfoService from "@/app.user/services/main-service.js";

export default {
  name: "checkoutCartPage",
  components: {
    "app-message": () => import("@/store.order/components/app-message"),
    "product-counter": () => import("@/store.product/components/product-counter")
  },
  mixins: [require("@/app/mixins/foundation")],
  data() {
    return {
      items: [],

      userInfo: {},
      comments: '',
      shippingFee: "FOB", //Default FOB fee

      //total: 0,

      submitted: false,
      //when submitted
      // messageModel: {
      //   enquiryId: null
      // },
      enquiryId: 0,
      enquiryNumber: null,

      uomList: [],
      shippingFeeList: [],

      //isValid: false,
      loading: false,
      errored: false,

      //animation
      cartButton: {
        status: 0 //1: ing, 2: ed
      },
    };
  },
  computed: {
    baseUrl() {
      return configService.baseUrl;
    },
    fullName() {
      return this.userInfo.lastName
        ? this.userInfo.lastName + " " + this.userInfo.firstName
        : null;
    },
    isAuthenticated() {
      //TODO-VICTOR: CHECK For token or key?
      return this.fullName !== null;
    },
    total(){
      var total = 0;
      this.items.forEach(function(item){
        // total+= item.totalCost;
        total+= (item.product.marketPrice * item.count)
      });
      return total;
    },
    shippingFeeSelected(){
      var idx = this.shippingFeeList.findIndex(e=>e.id=== this.shippingFee);
      return idx > -1 ? this.shippingFeeList[idx] : {};
    }
  },
  mounted() {
    EventBus.$on("refreshUserInfo", this.refreshUserInfo);

    let { owlDemo } = this.$refs;

    var owl = $(owlDemo);
    owl.owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      items: 1,
      dots: false,
      navText: ["<i class='arrow left'></i>", "<i class='arrow right'></i>"],
    });

    this.$nextTick(() => {
      // Custom Button
      for (let x = 0; x < 10; x++) {
        var className = ".detail-photo-" + x;
        $(className).bind("click", function() {
          $("#owl-demo").trigger("to.owl.carousel", x - 1);
        });
      }
    });
  },
  watch: {
    items:{
      deep: true,
      handler: function(/*oldValue, newValue*/){
        // console.log('TODO: update list, ',newValue);
      }
    }
  },
  created() {
    let _this = this;
    _this.userInfo = userInfoService.getCurrentUserInfo();

    this.init();
  },
  methods: {
    async init(){
      try{
        this.loading = true;

        var promises = [
          uomDataService.get(),
          shoppingCartDataService.getItems()
          ];

        const res = await Promise.all(promises);

        this.uomList = res[0].data;

        this.setShippingFeeList();

        this.setShoppingCartList(res[1]);

        //Refresh Fn
        this.$nextTick(function(){
          $(document).foundation();
        })

      }catch(error){
        console.error(error);
      }finally{
        this.loading = false;
      }
      
    },
    setShoppingCartList(data){
        // const defaultUomFk = this.uomList.length ?  this.uomList[0].id : null;
        // if (defaultUomFk){
        //   data.forEach(item => {
        //     item.product.uoMFk = defaultUomFk; //TODO-VICTOR: Add UOM to product Table(for Product default UOM)
        //   });
        // }
        data.forEach((item)=>{
          item.remarksParsed = item.remarks ? JSON.parse(item.remarks) : ''
        });
        this.items = data;
    },
    setShippingFeeList(){
      this.shippingFeeList = [
        { id: "FOB", name: 'FOB fee', hint: ''},
        { id: "CIF", name: 'CIF fee', hint: ''},
        { id: "DDU", name: 'DDU', hint: 'please offer your delivery address'}
        ];
    },
    onChangeProduct: _.debounce(async function(item){
      try{
        this.loading = true;

        item.totalCost = item.product.marketPrice * item.count;

        var promises = [
          shoppingCartDataService.updateShoppingCart(item)
          ];

        const res = await Promise.all(promises);

        this.updateShoppingCartItem(res[0].data)

      }catch(error){
        console.error(error);
      }finally{
        this.loading = false;
      }
      
      //shoppingCartDataService.add(item);
      // shoppingCartDataService.update(
      //               {
      //                   //id: item.id,
      //                   //userFk: userInfo.id,
      //                   productFk: item.id,
      //                   count: item.count,
      //                   totalCost: item.totalCost, 
      //                   //remarks: item.remarks,
      //                   uomFk: item.uomFk,
      //                   //isStandard: item.isStandard,
      //                   //version: 0,
      //                   //createdOn: item.createdOn
      //               });

    }, 1000),
    updateShoppingCartItem(item){
      let index = this.items.findIndex(e => e.id == item.id);
      this.items[index].totalCost = item.totalCost;
      this.items[index].version = item.version;
      // if(index > -1){
      //     this.items.splice(index, 1);
      // }
    },
    async deleteItem(item) {
      await shoppingCartDataService.delete(item);
      //this.items = await shoppingCartDataService.getItems();
      let index = this.items.findIndex(e => e.id == item.id);
      if(index > -1){
          this.items.splice(index, 1);
      }

      EventBus.$emit("refreshUserInfo");
    },
    async submitOrder() {

      let scope = this;

      this.cartButton.status = 1; //adding

      try {
        this.loading = true;
        const { data } = await shoppingCartDataService.submit(this.userInfo.id, JSON.stringify( this.comments), this.shippingFee);
        
        this.enquiryId = data.id;
        this.enquiryNumber = data.serialNumber;


        scope.cartButton.status = 2; //added
        $('.shopping-cart-btn div').addClass('shakeBit');

        //shoppingCartDataService.add(item);

        setTimeout(function() {
          // cart.removeClass("shakeBit");

          setTimeout(function() {
            scope.cartButton.status = 0; //reset
            $('.shopping-cart-btn div').removeClass('shakeBit');
            
          }, 500);

        }, 500);

        //Clear cart
        shoppingCartDataService.clear();
        EventBus.$emit("refreshUserInfo");


        window.scrollTo(0,0);

        this.submitted = true;


      } catch (error) {
        this.errored = true;
      } finally {
        this.loading = false;
      }
    },
    continueOrder() {
      this.$router.push("/search/query=all");
    },
    refreshUserInfo() {
      this.userInfo = userInfoService.getCurrentUserInfo();
    }
  },
};
</script>

<style lang="scss">
@import "./../../assets/sass/settings/settings";

.catalog-title::before {
  content: "";
}

img {
  max-width: 100%;
  width: auto \9;
  height: auto;
  vertical-align: middle;
  border: 0;
  -ms-interpolation-mode: bicubic;
}

#owl-demo .item img {
  display: block;
  width: 100%;
  height: auto;
}

.btns {
  display: table;
  margin: 30px auto;
}

.customNextBtn,
.customPreviousBtn {
  float: right;
  background: #2d9070;
  color: #fff;
  padding: 10px;
  margin-left: 5px;
  cursor: pointer;
}

.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.small-photos {
  .cell {
    padding-bottom: 1rem;
  }
}

.product-details {
  .details-header {
    font-size: 13px;
  }
  .details-description {
    font-size: 13px;
    p {
      font-size: 13px;
    }
  }
}
</style>

<style lang="scss" scoped>
#createAccountBtn{
  background:rgba(51, 51,51,.5);
  &:hover, 
  &:active{
    background:rgba(51, 51,51,.9);
  }
}


.product-quantity-info {
  margin-bottom: 0.5rem;

  input {
    font-size: 0.8125rem;
  }

  .quantity-line,
  .quantity-unit {
    font-size: 0.8125rem;
    line-height: 1rem;
    color: #232323;
    margin-bottom: 0.75rem;
    .selected {
      //padding-left: 5px;
      font-weight: 600;
      text-transform: capitalize;
    }
  }

  //quantity select 
  select{
    border: 1px solid #e9ecef;
    font-size: 0.8125rem;
    font-weight: 600;
    flex: 1 0;
    line-height: 1.65;
    height: 2.5em;
    margin: 0 auto;
    padding-left: 0.5rem;
    //padding-right: calc(82 / 16 * 1rem);

    


    text-align: left;
    width: 100%;
    //max-width: 100%;
max-width: calc(180 / 16 * 1rem); //AS CONTROL INPUT NUMBER

    vertical-align: top;
    -moz-appearance: textfield;
    &:focus{
      outline: 0;
      border: 0.125rem solid var(--primary-color);
    }
  }
}
</style>